import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import Tooltip from '@/src/components/common/Elements/Tooltip/Tooltip';
import { cn } from '@/src/util/ui';

export const Link = ({
  id = '',
  className = '',
  linkRef = null,
  disabled = false,
  disabledClass = 'disabled',
  'data-testid': dataTestId = null,
  tooltip = null,
  target = null,
  children,
  ...otherProps
}) => {
  let rel = otherProps.rel || 'noopener noreferrer';

  if (target === '_blank') {
    rel = rel.concat('');
  }
  const props = {
    ...otherProps,
    className: cn(className, disabled && disabledClass),
    disabled,
    'data-testid': dataTestId,
    target,
    rel,
  };

  if (tooltip) {
    const tooltipSetting = {
      id: `${className}_${id}`,
      place: tooltip.place || 'bottom',
      effect: tooltip.effect || 'solid',
    };

    return (
      <RouterLink ref={linkRef} to={props.href} {...props} data-tooltip-id={tooltipSetting.id}>
        {children}
        <Tooltip id={tooltipSetting.id} place={tooltipSetting.place} effect={tooltipSetting.effect}>
          {tooltip.content}
        </Tooltip>
      </RouterLink>
    );
  }

  return (
    <RouterLink ref={linkRef} to={props.href} {...props}>
      {children}
    </RouterLink>
  );
};

export default Link;
